import React, { Component, Fragment } from 'react';
import Routes from '../../routes';
import { Cadena_Listkey, Menu_Por_Usuario, GetVersion } from '../../request/rfc';
import  { Button } from './children/button';
import Wrapper from './children/wrapper';

export default class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            descripcion : '',
            buttonHomeExterno: [],
            buttonHomeInterno: [],
            version: ''
        };
    }

    componentDidMount() {
        GetVersion()
            .then(({ data: resp }) => {

                this.setState({ version: resp })

            })
            .catch((err) => { console.log(err); });
    }
    componentDidMount() {
        const { baseUrl } = this.state;
        const { isSiteInterno } = this.props;
        GetVersion()
            .then(({ data: resp }) => {

                this.setState({ version: resp })

            })
            .catch((err) => { console.log(err); });
        Cadena_Listkey()
        .then(({data: Response}) => {
            const { Message, Data } = Response;
            if(Message === '') {
                const descripcion = Data.Leyenda_Web;
                if(isSiteInterno == '0') {
                    this.setState({ descripcion, buttonHomeExterno: [ 
                                        { col: 'col-sm-6', to: `${baseUrl}${Routes.RFC}`, icon: 'fas fa-ticket-alt', label: 'Factura' },
                                        { col: 'col-sm-6', to: `${baseUrl}${Routes.Consulta}`, icon: 'fas fa-search', label: 'Consulta' }
                                    ]
                    });
                } else {
                    Menu_Por_Usuario()
                    .then(({ data: Response }) => {
                        const { Message, Data } = Response;
                        if(Message !== '') {
                            alert(Message);
                        } else {
                            const buttonHomeInterno = Data.map(item => Object.assign({}, item, {
                                col: 'col-sm-6 mb-5', to: item.Url, icon: item.Imagen, label: item.Nombre
                            }));
                            this.setState({ descripcion, buttonHomeInterno });
                        }
                    })
                    .catch((err) => { console.log(err); });
                }
            } else {
                alert(Message);
            }
        })
        .catch((err) => { console.log(err); });
    }

    render() {
        const { descripcion, buttonHomeExterno, buttonHomeInterno, version } = this.state;
        const { isSiteInterno } = this.props;
        let buttons = [];
        
        if(isSiteInterno == '1') {
            buttons = buttonHomeInterno.map((item, index)=> <Button key={index} 
                                                            col={item.col}
                                                            to={item.to} 
                                                            icon={item.icon}
                                                            label={item.label} />
                                                )
        } else {
            buttons = buttonHomeExterno.map((item, index)=> <Button key={index} 
                                                            col={item.col}
                                                            to={item.to} 
                                                            icon={item.icon}
                                                            label={item.label} />
                                                )
        }

        return (
            <Wrapper descripcion={descripcion}>
                <div className="row">
                    {buttons}
                </div>
                <p className="mt-5 mb-3 text-muted">© {new Date().toLocaleDateString()} , Versión {version}</p>
            </Wrapper>

        )
    }

};


// WEBPACK FOOTER //
// ./Public/src/js/component/home/index.jsx